// Copyright (c) Hamilton Manufacturing Corp.

import React from 'react';
import {
    Routes,
    Route,
    useLocation,
    Navigate,
} from 'react-router-dom';
import FourOhFour from '../../_ecom/pages/FourOhFour';
import Home from '../../_ecom/pages/Home';
import Locations from '../../_ecom/pages/Locations';
import UserManagement from '../../_ecom/pages/UserManagement';
import Checkout from '../../_ecom/pages/Checkout';
import Layout from '../../_ecom/pageLayout/Layout';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import Protected from './Protected';
import ShopRouter from '../../_ecom/pages/shop/ShopRouter';
import About from '../../_ecom/pages/About';
import PasswordRecovery from '../../_ecom/pages/PasswordRecovery';
import MAC from '../../_admin/MAC';
import SiteConfigUpdater from '../../_admin/SiteConfig/SiteConfigUpdater';
import Admin from '../../_admin/Admin';

const ScrollToTop = ({ children, location }) => {
    React.useEffect(() => window.scrollTo(0, 0), [location]);
    return children;
};

const EcomRouter = () => {
    useLocation();
    const { state: {
        site_config,
        active_user,
        app_key,
    } } = useGlobalState();

    if (!app_key) {
        return <Navigate to="/" replace />;
    }

    const getPath = tag => site_config.menuItems.find(e => e.tag === tag)?.href;

    return (
        <ScrollToTop location={window.location.pathname}>
            <Layout>
                <Routes>
                    {site_config.has_ecom && (
                        <>
                            <Route index path={`${getPath('_HOME')}`} element={<Home />} />
                            <Route path={`${getPath('_SHOP')}/*`} element={<ShopRouter />} />
                            <Route path={getPath('_LOCATIONS')} element={<Locations />} />
                            <Route path={getPath('_ABOUT')} element={<About />} />

                            <Route path='/checkout' element={<Checkout />} />
                            <Route path='/userManagement' element={
                                <Protected test={active_user.isLoggedIn}>
                                    <UserManagement />
                                </Protected>
                            } />
                        </>
                    )}
                    <Route path='/mmtpo' element={<MAC />} />
                    <Route path='/SiteConfigUpdater' element={<SiteConfigUpdater />} />
                    <Route path='/SiteAdmin' element={
                        <Protected test={active_user.isAdmin}>
                            <Admin />
                        </Protected>
                    } />
                    <Route path='/passwordRecovery' element={<PasswordRecovery />} />
                    <Route path='*' exact={true} element={site_config.has_ecom ? <FourOhFour /> : 'Please Open on a Mobile Device'} />
                </Routes>
            </Layout>
        </ScrollToTop>
    );
}

export default EcomRouter;
